
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/develop",
      function () {
        return require("private-next-pages/develop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/develop"])
      });
    }
  